<template>
  <core-modal-marketing
    tag="Digitization Services"
    :tag-icon="COMMON_ICONS.digitize"
    title="It all starts with a FOREVER Digitization Box"
    subtitle="Whether it's photos, tapes, or other media, we’ll convert them into digital files for easy enjoyment anywhere."
    :header-icon="COMMON_ICONS.digitize"
  >
    <digitization-box-selection
      container-class=""
      hide-header
      :upsell-tracking="upsellTracking"
    />
  </core-modal-marketing>
</template>

<script setup>
  defineProps({
    upsellTracking: Object
  });
</script>
